module.exports = __webpack_public_path__ + "img/esunbank.1f5206a5.png";